export { useFeedbackCollectorAnalytics } from "./use-feedback-collector-analytics";
